export const name = "BIT_XOR";
export const summary = `Performs a bitwise XOR operation on an expression.`;
export const reference = `
## BIT_XOR

Performs a bitwise XOR operation on an expression.

\`\`\`
BIT_XOR(
  [DISTINCT]
  expression
)
\`\`\`

### Description

Performs a bitwise XOR operation on \`expression\` and returns the result.

To learn more about the optional aggregate clauses that you can pass into this function, see Aggregate function calls.


### Supported Argument Types

- INT64


### Returned Data Types

INT64


### Examples



\`\`\`
SELECT BIT_XOR(x) AS bit_xor FROM UNNEST([5678, 1234]) AS x;

/*---------*
 | bit_xor |
 +---------+
 | 4860 |
 *---------*/
\`\`\`



\`\`\`
SELECT BIT_XOR(x) AS bit_xor FROM UNNEST([1234, 5678, 1234]) AS x;

/*---------*
 | bit_xor |
 +---------+
 | 5678 |
 *---------*/
\`\`\`



\`\`\`
SELECT BIT_XOR(DISTINCT x) AS bit_xor FROM UNNEST([1234, 5678, 1234]) AS x;

/*---------*
 | bit_xor |
 +---------+
 | 4860 |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
